import { postForm } from 'utils/rxfetch'

export default () => ({
  startVisualScan(data) {
    return postForm('/visual/scan', { url: data.url, genuine: data.genuine })
  },
})
